<div class="fix-header fix-sidebar card-no-border">
    <div id="main-wrapper">
        <ma-navigation-open class="fixing"></ma-navigation-open>
        <ma-sidebar style="display:none"></ma-sidebar>
        
        <div class="barTop">
            <router-outlet></router-outlet>	
        </div>
        
        <ma-footer></ma-footer>
    </div>
</div>

<ma-whatsapp-link></ma-whatsapp-link>

<script src="../assets/js/jquery.slimscroll.js"></script>
<script src="../assets/js/waves.js"></script>
<script src="../assets/js/sidebarmenu.js"></script>
<script src="js/custom.min.js"></script>